module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-right-cb40341f3d1266847d05dfa7fbe240c6.svg";